import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Skeleton from 'react-loading-skeleton';

const CooperativeMember = ({ data }) => {
    const [show, setShow] = useState(false);
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        fade: true,          // ✅ enables fade effect
        cssEase: "linear"
    };

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".col-inner p"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

        };

        // run on load
        setTimeout(equalHeight, 100);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    return (
        <div className='coop_member_sec'>
            <div className='row default-grid-gap'>
                {data?.map?.((item, index) => (
                    <div key={index} className='col-sm-6 col-md-4 col-lg-3 col-item my-4 my-lg-4' style={{ borderLeft: index % 4 === 0 ? "0" : "1px solid #ddd"}}>
                        {item?.Link ? (
                            <Link to={item?.Link} target='_blank' className='col-inner'>
                                <div className='coop_image'>
                                    <img src={`https://backend.bgzurlinden.ch${item?.Logo?.url}`} alt='Bernhard Boden AG' />
                                </div>
                                <div className='coop_title fs_26 fw-550'>{item?.Titel}</div>
                                <p>{item?.Text}</p>
                                <div className='coop_website'>
                                    {item?.Link_Text}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <rect width="40" height="40" rx="20" fill="#E72B6A" />
                                        <path d="M22.6275 26.7237C22.3653 26.971 21.9403 26.971 21.6781 26.7237C21.4159 26.4763 21.4159 26.0752 21.6781 25.8278L27.4691 20.3637L21.6781 14.8996C21.4159 14.6522 21.4159 14.2512 21.6781 14.0038C21.9403 13.7564 22.3653 13.7564 22.6275 14.0038L28.8932 19.9158C29.1554 20.1632 29.1554 20.5643 28.8932 20.8116L22.6275 26.7237Z" fill="white" />
                                        <path d="M12.3066 20.9972C11.9359 20.9972 11.6353 20.7136 11.6353 20.3637C11.6353 20.0139 11.9359 19.7303 12.3066 19.7303L28.4185 19.7303C28.7893 19.7303 29.0898 20.0139 29.0898 20.3637C29.0898 20.7136 28.7893 20.9972 28.4185 20.9972L12.3066 20.9972Z" fill="white" />
                                    </svg>
                                </div>
                            </Link>
                        ) : (
                            <div className='col-inner'>
                                <div className='coop_image'>
                                    <img src={`https://backend.bgzurlinden.ch${item?.Logo?.url}`} alt='Bernhard Boden AG' />
                                </div>
                                <div className='coop_title fs_26 fw-550'>{item?.Titel}</div>
                                <p>{item?.Text}</p>
                                {/* <div className='coop_website'>
                                    {item?.Link_Text}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <rect width="40" height="40" rx="20" fill="#E72B6A" />
                                        <path d="M22.6275 26.7237C22.3653 26.971 21.9403 26.971 21.6781 26.7237C21.4159 26.4763 21.4159 26.0752 21.6781 25.8278L27.4691 20.3637L21.6781 14.8996C21.4159 14.6522 21.4159 14.2512 21.6781 14.0038C21.9403 13.7564 22.3653 13.7564 22.6275 14.0038L28.8932 19.9158C29.1554 20.1632 29.1554 20.5643 28.8932 20.8116L22.6275 26.7237Z" fill="white" />
                                        <path d="M12.3066 20.9972C11.9359 20.9972 11.6353 20.7136 11.6353 20.3637C11.6353 20.0139 11.9359 19.7303 12.3066 19.7303L28.4185 19.7303C28.7893 19.7303 29.0898 20.0139 29.0898 20.3637C29.0898 20.7136 28.7893 20.9972 28.4185 20.9972L12.3066 20.9972Z" fill="white" />
                                    </svg>
                                </div> */}
                            </div>
                        )}

                    </div>
                ))}
            </div>
        </div>
    )
}

export default CooperativeMember